import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import AuditTrailReportContMain from "presentation/view/container/AuditTrailReport/AuditTrailReportContMain";

CommonEntrypoint(<AuditTrailReportContMain/>)